// extracted by mini-css-extract-plugin
export default {"frameContainer":"styles_frameContainer__NMtc+","innerSquare":"styles_innerSquare__Gf7Wv","downArrow":"styles_downArrow__KGAVS","upArrow":"styles_upArrow__7I9G3"};